<template>
  <div class="about">
    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="container has-text-centered">
          <div class="column is-4 is-offset-4">
            <h3 class="title">Password Recovery</h3>
            <div class="box">
              <div v-if="recoveryError" class="notification is-danger">
                Sorry, an error occured during recovery:
                <br />
                {{recoveryErrorMsg}}
              </div>

              <div
                v-if="recoveryAttemptSuccess"
                class="notification is-success"
              >We sent you an email with an recovery link to access your account.</div>
              <div v-if="!recoveryAttemptSuccess">
              <form  @submit.prevent="attemptRecovery">
                <div class="field">
                  <div class="control">
                    <input
                      v-model="email"
                      required
                      class="input"
                      type="email"
                      placeholder="Your Email"
                      autofocus
                    />
                  </div>
                </div>

                <button
                  v-bind:class="{'is-loading': loading}"
                  class="button is-block is-primary is-fullwidth"
                >Recover</button>
              </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import atomic from "atomicjs";
export default {
  name: "forgotpassword",
  data: function () {
    return {
      recoveryError: false,
      recoveryErrorMsg: "",
      recoveryAttemptSuccess: false,
      email: null,
      loading: false,
    };
  },
  methods: {
    attemptRecovery: function () {
      this.recoveryError = false;
      this.loading = true;
      atomic(process.env.API_HOST + "auth/forgot-password", {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        data: { email: this.email },
      }).then(response => {
          this.recoveryAttemptSuccess=true
          this.loading= false;
        })
        .catch(error => {
          this.loading= false;
          this.recoveryError = true;
          if (error.responseText.trim() == "ERROR_INVALID_EMAIL") {
              this.recoveryErrorMsg =
                "Unknown email format. Please enter a valid email address.";
            } else {
              this.recoveryErrorMsg =
                "OMG, something went wrong. It was us, not you and the team was already notified. Please try again later.";
            }
        });
    }
  },
};
</script>

